export function getConfiguredDIAssetsBaseUrl() {
  return ((import.meta.env['VITE_DI_ASSETS_BASE_URL'] as string | undefined) || '').replace(/\/+$/, '')
}

export function getDIAssetsBaseUrl() {
  const baseUrl = getConfiguredDIAssetsBaseUrl()
  if (!baseUrl) {
    throw new Error('DI assets public base URL is not configured.')
  }

  return baseUrl
}

export function buildDIAssetUrl(key: string | null | undefined, version?: string | null) {
  const normalizedKey = (key || '').replace(/^\/+/, '')
  if (!normalizedKey) return ''

  const url = `${getDIAssetsBaseUrl()}/${normalizedKey}`
  const normalizedVersion = (version || '').trim()

  if (!normalizedVersion) return url

  return `${url}?v=${encodeURIComponent(normalizedVersion)}`
}
